export function getFilteredLuminaireLineProductsExt(context) {

    if (!context.products || context.products === 'undefinded' || context.products.length < 1) {
        return null;
    }

    const subtypeOrder = [
        'rope_suspension_loop',
        'rope_suspension_carabiner',
        'rope_suspension_concrete_anchor',
        'rope_suspension_trapezoidal_sheet_hook',
        'suspension_hook'
    ];

    let suspensions = context.products.suspension?.filter(product => product.enabled)
        .sort(function (a, b) {
            if (a.size_x < b.size_x) {
                return -1;
            }
            if (a.size_x > b.size_x) {
                return 1;
            }
            return 0;
        })
        .sort((a, b) => {
            const indexA = subtypeOrder.indexOf(a.product_subtype);
            const indexB = subtypeOrder.indexOf(b.product_subtype);
            return indexA - indexB;
        });


    let warranties = context.products.warranty?.filter(product => product.enabled);
    let remote_controls = context.products.remote_control?.filter(product => product.enabled);
    let connecting_cable = context.products.connecting_cable?.filter(product => product.enabled);
    let ceiling_mounts = context.products.ceiling_mount?.filter(product => product.enabled);
    let mounting_adapters = context.products.mounting_adapter?.filter(product => product.enabled);
    let luminaire_control_submodules = context.products.luminaire_control_submodule?.filter(product => product.enabled);
    let blind_modules = context.products.blind_module?.filter(product => product.enabled && product.size_x === 168);

    // depending on serie. if serie empty at product, it is for all series
    let universal_connector_submodules = context.products.universal_connector_submodule?.filter(product => product.enabled
        && (!product.serie || context.selectedSerie.includes(product.serie))
    );

    // partly depending on serie
    let emergency_lights = context.products.emergency_light?.filter(product => product.enabled);
    // 065534 Emergency light with battery only for serie Eco
    if (context.selectedSerie.includes('max')) {
        emergency_lights = context.products.emergency_light?.filter(product => product.sku !== '065534' && product.enabled);
    }

    // depending on serie only
    let connecting_cable_middle = context.products.connecting_cable_middle?.filter(product => product.enabled
            && context.selectedSerie.includes(product.serie)
        )
        .sort(function (a, b) {
            if (a.size_x < b.size_x) {
                return -1;
            }
            if (a.size_x > b.size_x) {
                return 1;
            }
            return 0;
        });

    let universal_adapters = context.products.universal_adapter?.filter(product => product.enabled
        && context.selectedSerie.includes(product.serie)
    ).sort(function (a, b) {
        if (a.title < b.title) {
            return -1;
        }
        if (a.title > b.title) {
            return 1;
        }
        return 0;
    });

    // depending on housing only
    let cable_routes = context.products.cable_route?.filter(product => product.enabled);
    let mount_connectors = context.products.mount_connector?.filter(product => product.enabled);

    if (context.selectedHousingColor
        && context.selectedHousingColor !== 'undefined'
        && context.selectedHousingColor !== ''
    ) {
        cable_routes = cable_routes?.filter(product => !!product.luminaire_selection_options.find(el => el.luminaire_selection_step_id === 2 && el.id === context.selectedHousingColor));
        mount_connectors = mount_connectors?.filter(product => !!product.luminaire_selection_options.find(el => el.luminaire_selection_step_id === 2 && el.id === context.selectedHousingColor));
    }

    // depening on Serie & Housing Color
    let electrical_feeds = context.products.electrical_feed?.filter(product => product.enabled);
    let mountingrails = context.products.mountingrail?.filter(product => product.enabled);
    let mountingrails_with_connectors = context.products.mountingrail_with_connectors?.filter(product => product.enabled);
    let luminaire_controls = context.products.luminaire_control?.filter(product => product.enabled);
    let universal_connectors = context.products.universal_connector?.filter(product => product.enabled);

    if (context.selectedSerie
        && context.selectedHousingColor) {

        electrical_feeds = electrical_feeds?.filter(product =>
            context.selectedSerie.includes(product.serie)
            && !!product.luminaire_selection_options.find(el => el.luminaire_selection_step_id === 2 && el.id === context.selectedHousingColor)
        );

        let mountingRailSubtype = 'mounting_rail_7_poles';
        if (context.selectedSerie === 'max_10') {
            mountingRailSubtype = 'mounting_rail_10_poles';
        } else if (context.selectedSerie === 'max_12') {
            mountingRailSubtype = 'mounting_rail_12_poles';
        } else if (context.selectedSerie === 'max_14') {
            mountingRailSubtype = 'mounting_rail_14_poles';
        }

        mountingrails = mountingrails?.filter(product =>
            context.selectedSerie.includes(product.serie)
            && product.product_subtype === mountingRailSubtype
            && !!product.luminaire_selection_options.find(el => el.luminaire_selection_step_id === 2 && el.id === context.selectedHousingColor)
        );

        mountingrails_with_connectors = mountingrails_with_connectors?.filter(product =>
            context.selectedSerie.includes(product.serie)
            && !!product.luminaire_selection_options.find(el => el.luminaire_selection_step_id === 2 && el.id === context.selectedHousingColor)
        );

        luminaire_controls = luminaire_controls?.filter(product =>
                context.selectedSerie.includes(product.serie)
                && !!product.luminaire_selection_options.find(el => el.luminaire_selection_step_id === 2 && el.id === context.selectedHousingColor)
            )
            .sort(function (a, b) {
                if (a.title < b.title) {
                    return -1;
                }
                if (a.title > b.title) {
                    return 1;
                }
                return 0;
            });

        universal_connectors = universal_connectors?.filter(product =>
            context.selectedSerie.includes(product.serie)
            && !!product.luminaire_selection_options.find(el => el.luminaire_selection_step_id === 2 && el.id === context.selectedHousingColor)
        );

    }


    // depending on Optic

    let optics = null;

    if (context.selectedOptics === 7 || context.selectedOptics === 37) {
        // ASY links = 7 & rechts = 37
        optics = context.products.optic_asy;
    } else if (context.selectedOptics === 8) {
        // DASY = 8
        optics = context.products.optic_dasy;
    } else if (context.selectedOptics === 6) {
        // BATWING = 6
        optics = context.products.optic_batwing;
    } else if (context.selectedOptics === 5) {
        // INTENSE = 5
        optics = context.products.optic_intense;
    } else if (context.selectedOptics === 41) {
        // OPAL = 41
        optics = context.products.optic_opal;
    }

    if (context.products.optic && context.products.optic.length) {
        optics = context.products.optic.filter(product => product.title.contains());
    }

    // depending on protection class. IP 44 = 14, IP 55 = 15, IP 65 = 16
    let protection_class = null;
    if (context.selectedProtectionClass === 15) {
        protection_class = context.products.protection_class.filter(product => product.product_subtype === 'protection_class_ip55');
    } else if (context.selectedProtectionClass === 16) {
        protection_class = context.products.protection_class.filter(product => product.product_subtype === 'protection_class_ip65')
    } else {
        protection_class = null;
    }

    return {
        ceiling_mounts,
        emergency_lights,
        luminaire_controls,
        luminaire_control_submodules,
        suspensions,
        universal_adapters,
        mounting_adapters,
        cable_routes,
        blind_modules,
        mount_connectors,
        electrical_feeds,
        mountingrails,
        mountingrails_with_connectors,
        warranties,
        remote_controls,
        universal_connectors,
        universal_connector_submodules,
        optics,
        connecting_cable,
        connecting_cable_middle,
        protection_class
    };


}
